module.exports = __webpack_public_path__ + "assets/img/develop.1875d57a.png";